// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1Izrl","inputDescription":"styles_inputDescription__tJQLC"};